<template>
  <div class="report-service" v-if="load">
    <div class="report">
      <report-menu v-model="date"></report-menu>
      <div class="main">
        <h2 class="main-title">Обслуговування</h2>
        <section>
          <header>
            <div class="col-td">Номенклатура</div>
            <div class="col-td">Кількість</div>
            <div class="col-td">Ціна</div>
            <div class="col-td">СУМА (₴)</div>
          </header>
          <div class="table-row first-row">
            <div class="col-td">Вього</div>
            <div class="col-td">{{ totalTransactionsByGood.totalAmount}}</div>
            <div class="col-td">{{ totalTransactionsByGood.avgPrice | toCurrency }}</div>
            <div class="col-td">{{ totalTransactionsByGood.totalSum | toCurrency }}</div>
          </div>
          <template  v-for="(tr, i) in transactionsByGood" >
            <div class="table-row" :key="i">
              <div class="col-td desktop" style="width: 10%" >{{tr.nameGood}}</div>
              <div class="col-td desktop"  style="width: 10%">{{tr.amount }}</div>
              <div class="col-td desktop"  style="width: 10%">{{tr.price | toCurrency }}</div>
              <div class="col-td desktop"  style="width: 10%">{{tr.summa | toCurrency}}</div>
            </div>
          </template>
        </section>
      </div>
    </div>
      <br>
    <div class="main">
      <div class="main-header flex-justify">
        <div class="inner-addon">
          <button v-if="item.length >0 || dateFilter.length > 0 || itemGood.length >0 " @click="item=[], itemGood=[], dateFilter=[]" class="dropbtn" v-tooltip.top-center="'Скинути всі фільтри'" ><svg class="hover" width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 4L9 12V18L15 21V12L20 4H4Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M29 12L20 21M20 12L29 21" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          </button>
        </div>
      <div class="header-right">


        <div class="select" >
          <select v-model="limit">
            <option value=10>10</option>
            <option value=20>20</option>
            <option value=40>40</option>
            <option value=50>50</option>
            <option value=100>100</option>
          </select>
        </div>
      </div>
      </div>
      <section>
        <header>
          <div class="col-td"  style="width: 15%">
            <div class="dropdown">
            <button @click="isActive=!isActive" class="dropbtn" >
              <svg :class="{active: item.length>0}" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 9V15L12 18V9L17 1H1Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <div id="myDropdown" :class="{show: isActive}" class="dropdown-content">
              <div class="addon left-addon">
                <button  @click="item=[]" class="dropbtn" v-tooltip.top-center="'Скинути'" ><svg class="hover" width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4L9 12V18L15 21V12L20 4H4Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M29 12L20 21M20 12L29 21" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </button>
                <input type="text" placeholder="Пошук.." class="myInput" v-model="search">
                <svg class="glyphicon" width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="13.5" cy="8.5" r="8" fill="white" stroke="#C4C4C4"/>
                  <line x1="8.06066" y1="14.0607" x2="1.06066" y2="21.0607" stroke="#C4C4C4" stroke-width="3"/>
                </svg>
              </div>
              <div class="checkbox" v-for="card in cardList" :key="card.cardNo" >
                <input type="checkbox" class="custom-checkbox" v-model="item" :id="'category_' + card.cardNo" :value="card.cardNo"  />
                <label :for="'category_' + card.cardNo">{{ card.cardNo }} - {{ card.cardDescription }}</label>
              </div>
<!--              <a v-for="card in filteredList" :key="card" :href="'#'+card">{{card}}</a>-->
            </div>
            </div>
            <a @click.stop="sort=OrderByCardNo.reverse()[0]">Картка/Тримач
              <span class="arrow">
                <svg :class="{active: sort==2}" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 6L6 1L1 6" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg :class="{active: sort==1}" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </span>
            </a>
          </div>
          <div class="col-td"  style="width: 10%">
            <div class="dropdown">
              <button @click="isActiveDate=!isActiveDate" class="dropbtn" >
                <svg :class="{active: dateFilter.length>0}" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L6 9V15L12 18V9L17 1H1Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <div :class="{show: isActiveDate}" class="dropdown-content">
                <div class="addon left-addon">
                  <date-picker
                      v-model="dateFilter"
                      type="datetime"
                      range
                      :lang="lang"
                      :disabled-date="disabledFilterDate"
                      format="DD.MM.YYYY HH:mm:ss"
                      placeholder="Select datetime range"
                  ></date-picker>
                </div>
              </div>
            </div>
            <a @click.stop="sort=OrderByTransDate.reverse()[0]">Дата
              <span class="arrow">
                <svg :class="{active: sort==4}" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 6L6 1L1 6" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg :class="{active: sort==3}" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </span>
            </a>
            </div>
          <div class="col-td" style="width: 10%">
            <div class="dropdown">
              <button @click="isActiveGood=!isActiveGood" class="dropbtn" >
                <svg :class="{active: itemGood.length>0}" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L6 9V15L12 18V9L17 1H1Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <div id="myDropdownGood" :class="{show: isActiveGood}" class="dropdown-content">
                <div class="addon left-addon">
                  <button  @click="itemGood=[]" class="dropbtn" v-tooltip.top-center="'Скинути'" ><svg class="hover" width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 4L9 12V18L15 21V12L20 4H4Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M29 12L20 21M20 12L29 21" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  </button>
                  <input type="text" placeholder="Пошук.." class="myInput" v-model="searchGood">
                  <svg class="glyphicon" width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="13.5" cy="8.5" r="8" fill="white" stroke="#C4C4C4"/>
                    <line x1="8.06066" y1="14.0607" x2="1.06066" y2="21.0607" stroke="#C4C4C4" stroke-width="3"/>
                  </svg>
                </div>
                <div class="checkbox" v-for="good in goodList" :key="good.idGood" >
                  <input type="checkbox" class="custom-checkbox" v-model="itemGood" :id="'category_' + good.idGood" :value="good.idGood"  />
                  <label :for="'category_' + good.idGood">{{ good.goodShortName }}</label>
                </div>
                <!--              <a v-for="card in filteredList" :key="card" :href="'#'+card">{{card}}</a>-->
              </div>
            </div>
            <a @click.stop="sort=OrderByGoodName.reverse()[0]">Послуга
              <span class="arrow">
                <svg :class="{active: sort==6}" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 6L6 1L1 6" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg :class="{active: sort==5}" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </span>
            </a>
            </div>
          <div class="col-td" style="width: 10%">
            <a @click.stop="sort=OrderByAmount.reverse()[0]">Кількість
              <span class="arrow">
                <svg :class="{active: sort==8}" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 6L6 1L1 6" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg :class="{active: sort==7}" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </span>
            </a>
            </div>
          <div class="col-td" style="width: 10%">
            <a @click.stop="sort=OrderByPrice.reverse()[0]">Ціна
              <span class="arrow">
                <svg :class="{active: sort==10}" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 6L6 1L1 6" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg :class="{active: sort==9}" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </span>
            </a>
          </div>
          <div class="col-td" style="width: 10%">
            <a @click.stop="sort=OrderBySum.reverse()[0]">СУМА (₴)
              <span class="arrow">
                <svg :class="{active: sort==12}" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 6L6 1L1 6" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg :class="{active: sort==11}" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </span>
            </a>
            </div>
          <div class="col-td text-align-end" style="width: 30%">ТО</div>
        </header>
        <template  v-for="(tr, i) in transactions" >
          <div class="table-row" :key="i">
            <div class="col-td desktop" style="width: 15%">{{tr.cardNo}}<br>{{tr.cardOwner}}</div>
            <div class="col-td desktop" style="width: 15%">{{tr.transDate | formatDate}}</div>
            <div class="col-td desktop" style="width: 10%" >{{tr.goodName}}</div>
            <div class="col-td desktop"  style="width: 10%">{{tr.amount | toCurrency }}</div>
            <div class="col-td desktop"  style="width: 10%">{{tr.price | toCurrency }}</div>
            <div class="col-td desktop"  style="width: 10%">{{tr.transSum | toCurrency}}</div>
            <div class="col-td desktop big text-align-end" style="width: 30%">{{tr.station}}</div>
            <div @click="showMobile(tr)" class="col-td mobile" style="width: 60%"><span class="light-gray">{{tr.transDate | formatDateMob}}</span><br>{{tr.cardNo}}<br><span class="main-blue">{{tr.cardOwner}}</span></div>
            <div @click="showMobile(tr)"  class="col-td mobile" style="width: 40%; text-align: end">{{tr.transSum | toCurrency}}</div>
            <div @click="showTablet(tr)" class="col-td landscape" style="width: 10%"><span class="light-gray">{{tr.transDate | formatDateMob}}</span></div>
            <div @click="showTablet(tr)" class="col-td landscape" style="width: 25%;">{{tr.cardNo}}</div>
            <div @click="showTablet(tr)" class="col-td landscape" style="width: 25%;"><span class="main-blue">{{tr.cardOwner}}</span></div>
            <div @click="showTablet(tr)"  class="col-td landscape" style="width: 40%; text-align: end">{{tr.transSum | toCurrency}}</div>
          </div>
        </template>
      </section>

      <div v-if="totalTransactions.totalCount/limit > 1" class="container">
        <paginate
            :page-count="Math.ceil(totalTransactions.totalCount/limit)"
            :click-handler="changePage"
            :page-range="4"
            :margin-pages="4"
            :initial-page="page"
            :prev-text="'Попередня'"
            :next-text="'Наступна'"
            :container-class="'pagination'">
        </paginate>
        <div class="pagination-info">
          Показується з {{page * limit - limit + 1}} по {{pageTotal.countOnPage === Number(limit) ? page * limit :  totalTransactions.totalCount }} із {{ totalTransactions.totalCount }}
        </div>
      </div>
<!--      <pre>-->
<!--        {{transactions}}-->
<!--      </pre>-->

    </div>
    <div>
      <button @click="turnoverDownload">Скачать Exel 1С формат</button>
    </div>

  </div>
</template>
<script>
import ReportMenu from '../components/ReportMenu'
import  moment from "moment";
import Paginate from 'vuejs-paginate'
import qs from 'qs'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/uk';
moment.defineLocale('uk', null)
export default {
  name: 'Service',
  components: {
    ReportMenu,
    Paginate,
    DatePicker
  },
  watch: {
    date: function (){
      this.load = false
      this.getData()
    },
    dateFilter: function (){
      // this.load = false
      this.getData()
    },
    picked: function () {
      this.load = false
      this.getData()
    },
    page: function () {
      // this.load = false
      this.getData()
    },
    item: function () {
      // this.load = false
      this.getData()
    },
    sort: function () {
      // this.load = false
      this.getData()
    },
    itemGood: function () {
      // this.load = false
      this.getData()
    },
    limit: function (){
      this.getData()
      this.page = 1
    }
  },
  data() {
    return {
      open: true,
      dateFilter: [],
      OrderByCardNo: [2,1],
      OrderByTransDate: [4,3],
      OrderByGoodName: [6,5],
      OrderByAmount: [8,7],
      OrderByPrice: [10,9],
      OrderBySum: [12,11],
      cards: [],
      goods: [],
      sort: 4,
      item: [],
      itemGood: [],
      search:'',
      searchGood:'',
      isActive: false,
      isActiveGood: false,
      isActiveDate: false,
      limit: 10,
      page: 1,
      pageTotal: {},
      picked: 1,
      load: false,
      transactions: [],
      totalTransactions: {},
      date: [new Date(moment().format('YYYY, MM, 01') ), new Date() ],
      transactionsByGood: [],
      totalTransactionsByGood: {},
      lang: {
        monthFormat: 'MMMM'
      },
    }
  },
  created() {
    this.getData()
  },
  computed: {
    transactionDates(){
      if (this.dateFilter.length === 0 || this.dateFilter[0]===null || this.dateFilter[1]===null) {
            return {begDate: moment(this.date[0]).format('YYYY-MM-DD') + ' 00:00:00',
            endDate: moment(this.date[1]).format('YYYY-MM-DD') + ' 23:59:59'}
      } else {
        return {begDate: moment(this.dateFilter[0]).format('YYYY-MM-DD HH:mm:ss'),
          endDate: moment(this.dateFilter[1]).format('YYYY-MM-DD HH:mm:ss')}
      }
    },
    cardList() {
      return this.cards.filter(card => {
        return card.cardNo.toLowerCase().includes(this.search.toLowerCase()) || card.cardDescription.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    goodList() {
      return this.goods.filter(good => {
        return good.goodName.toLowerCase().includes(this.searchGood.toLowerCase()) || good.goodShortName.toLowerCase().includes(this.searchGood.toLowerCase())
      })
    }
  },
  mounted () {
  },
  methods: {
    turnoverDownload: function () {

      this.axios.get('/userservice/v1/User/turnover-download', {params:
            {begDate: moment(this.date[0]).format('YYYY-MM-DD') + ' 00:00:00', endDate: moment(this.date[1]).format('YYYY-MM-DD') + ' 00:00:00'},
         responseType: 'blob'}
      )
          .then(( data ) => {
            const file = data.data
            const downloadUrl = window.URL.createObjectURL(new Blob([file]));

            const link = document.createElement('a');

            link.href = downloadUrl;

            link.setAttribute('download', "Обіг для клієнта(згрупований) з" + moment(this.date[0]).format('DD-MM-YYYY') + " до " + moment(this.date[1]).format('DD-MM-YYYY')  + '.xlsx'); //any other extension
            document.body.appendChild(link);

            link.click();

            link.remove();

          })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              this.$store.dispatch("logout")
            } else {
              console.log(error);
              this.errored = true;
            }
          })
    },
    disabledFilterDate: function (date){
      return date > this.date[1] || date < this.date[0]
    },
    changePage: function (pageNum){
      this.page = pageNum
    },
    getData: function (){
      this.axios.all([
        this.axios.get('/userservice/v1/User/transactions',
            {params:
                  {
                    begDate: this.transactionDates.begDate,
                    endDate:  this.transactionDates.endDate,
                    topTransactions: this.limit,
                    page: this.page,
                    sortingTransactions: this.sort,
                    cardsList: this.item,
                    goodsList: this.itemGood },
                  paramsSerializer: params => {return qs.stringify(params)
          } }),
        this.axios.get('/userservice/v1/User/transactions-by-good', {params: {begDate: moment(this.date[0]).format('YYYY-MM-DD') + ' 00:00:00', endDate: moment(this.date[1]).format('YYYY-MM-DD') + ' 00:00:00'}}),
        this.axios.get('/userservice/v1/Card/cards-for-transactions', {params: {begDate: moment(this.date[0]).format('YYYY-MM-DD') + ' 00:00:00', endDate: moment(this.date[1]).format('YYYY-MM-DD') + ' 00:00:00'}}),
        this.axios.get('/userservice/v1/Goods/goods-for-transactions', {params: {begDate: moment(this.date[0]).format('YYYY-MM-DD') + ' 00:00:00', endDate: moment(this.date[1]).format('YYYY-MM-DD') + ' 00:00:00'}})
      ]).then(
          this.axios.spread((trans, transactionsByGood, cards, goods) => {
            this.transactions = trans.data.data
            this.pageTotal = trans.data.pageTotal
            this.totalTransactions =  trans.data.total
            this.transactionsByGood = transactionsByGood.data.data
            this.totalTransactionsByGood =  transactionsByGood.data.total
            this.cards = cards.data
            this.goods = goods.data
            //  this.info = info.data
          })
      )
          .catch(error => {
            console.log('error_get_data');
            console.log(error);
            this.errored = true;
          })
          .finally(() => (
              this.load = true)
          )
    },
  }
}
</script>
<style>
.arrow {
  display: inline-flex;
  flex-direction: column;
}
.custom-checkbox {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.custom-checkbox+label {
  display: inline-flex;
  align-items: center;
  user-select: none;
}
.custom-checkbox+label::before {
  content: '';
  display: inline-block;
  width: 1.2em;
  height: 1.2em;
  flex-shrink: 0;
  flex-grow: 0;
  border: 1px solid #adb5bd;
  border-radius: 0.25em;
  margin-right: 0.5em;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50% 50%;
}
.custom-checkbox:checked+label::before {
  border-color: #4E4CC7;
  background-color:  #4E4CC7;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e");
}
/* стили при наведении курсора на checkbox */
.custom-checkbox:not(:disabled):not(:checked)+label:hover::before {
  border-color: #b3d7ff;
}
/* стили для активного состояния чекбокса (при нажатии на него) */
.custom-checkbox:not(:disabled):active+label::before {
  background-color: #b3d7ff;
  border-color: #b3d7ff;
}
/* стили для чекбокса, находящегося в фокусе */
.custom-checkbox:focus+label::before {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
/* стили для чекбокса, находящегося в фокусе и не находящегося в состоянии checked */
.custom-checkbox:focus:not(:checked)+label::before {
  border-color: #80bdff;
}
/* стили для чекбокса, находящегося в состоянии disabled */
.custom-checkbox:disabled+label::before {
  background-color: #e9ecef;
}

.dropdown-content::-webkit-scrollbar {
  width: 10px;               /* width of the entire scrollbar */
}

.dropdown-content::-webkit-scrollbar-track {
  background: #BDBDBD;        /* color of the tracking area */
}

.dropdown-content::-webkit-scrollbar-thumb {
  background-color: #666666;    /* color of the scroll thumb */
  border-radius: 20px;       /* roundness of the scroll thumb */
  border: 3px solid #666666;  /* creates padding around scroll thumb */
}
.hover:hover path{
  fill: var(--soft-purple);
  stroke: var(--soft-purple);
}
svg.active,
svg.active path {
  //fill: var(--soft-purple);
  stroke: var(--soft-purple);
}
.addon {
  display: flex;
  position: relative;
}
.addon .glyphicon {
  position: absolute;
  padding: 10px;
  pointer-events: none;
}
.addon .glyphicon{
  left: 30px;
}
.flex-right {
  justify-content: end;
}
.report-service {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 80%;
  align-self: center;
  justify-self: center;
}
.report-service .report {
  width: 100%;
}
.report-service > .main {
  width: 100%;
}
.dropbtn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  margin: 0;

}
/* The search field */
.myInput {
  border-box: box-sizing;
  background-position: 14px 12px;
  background-repeat: no-repeat;
  font-size: 16px;
  padding: 14px 20px 12px 45px;
  border: none;
  border: 1px solid #ddd;
  margin-left: 7px;
}

/* The search field when it gets focus/clicked on */
.myInput:focus {outline: 1px solid var(--soft-purple);}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #FFFFFF;
  min-width: 230px;
  border: 1px solid #ddd;
  z-index: 1;
  max-height: 300px;
  overflow-y: auto;
}

/* Links inside the dropdown */
.dropdown-content div.checkbox{
  color: black;
  padding: 8px 6px;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {background-color: #f1f1f1}

/* Show the dropdown menu (use JS to add this class to the .dropdown-content container when the user clicks on the dropdown button) */
.show {display:block;}
</style>